module.exports = __webpack_public_path__ + "img/banner1.0a15cd3b.png";